enum MeetingMessageButtonEntrySource {
    LVConversation = 0,
    LVMessage = 1,
    LVCalendarItems = 2,
}
export default MeetingMessageButtonEntrySource;
